import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 10.5V6H3v12h14v-4.5l4 4v-11l-4 4z"
}), 'VideocamSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideocamSharp.js
// module id = 7058
// module chunks = 2